module.exports = __webpack_public_path__ + "assets/6c0bd91a760af916e202ea26e5a3f775.svg";